function lowerFirstLetter(string=''){
    return string.charAt(0).toLowerCase() + string.slice(1);
}

export default lowerFirstLetter